import { BehaviorSubject, combineLatest } from "rxjs";
import { filter, map } from "rxjs/operators";
import { FiltersAbstractService } from "src/app/common-page-components/classes/filters-abstract-service";
import { ComboStoreComponent, EventAthleteResultsCombo } from "src/app/common-page-components/stores/filters-store/filters-store";
import { FiltersAthleteGeneralService } from "../../services/filters-athlete-general.service";
import * as i0 from "@angular/core";
import * as i1 from "../../services/filters-athlete-general.service";
export class AthleteWcupRankingFiltersService extends FiltersAbstractService {
    constructor(common_service) {
        super();
        this.common_service = common_service;
        /**
         * Categories combo from general athlete to get the athlete categories.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.athleteCategoriesCombo = this.common_service.athleteCategoriesCombo;
        /**
         * Categories combo from general athlete to get the athlete categories.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.categoriesCombo = new ComboStoreComponent('Categories: ', 'CatName', 'wcrup-category-combo', undefined, undefined, undefined, undefined);
        /**
         * A lock to only dispatch the events on the method getDataStreamWithFilters when categories are ready and filtered.
         *
         * @memberof AthleteWcupRankingFiltersFinalsService
         */
        this.categoriesReady = new BehaviorSubject(false);
        /**
         * Event type combo.
         *
         * @memberof ResultsAthleteFiltersService
         */
        this.eventTypeCombo = new EventAthleteResultsCombo("Event:", "event-results-combo");
        /**
         * The filters of the BootstrapAthleteWcupRankingComponent page.
         *
         * @memberof BootstrapAthleteWcupRankingComponent
         */
        this.filtersType = [
            this.categoriesCombo.filterInfo,
            this.eventTypeCombo.filterInfo
        ];
        this.eventTypeCombo.setData([].concat(...(this.eventTypeCombo['extraOptions']).map(value => value.item)), { Name: "Individual", Value: 0 });
        this.eventTypeCombo.setSelected({ Name: "Individual", Value: 0 });
        const categoriesToSet = [].concat(...this.athleteCategoriesCombo.data.filter(value => ['RM', 'RW', 'CM', 'CW'].indexOf(value.Cat) != -1));
        this.categoriesCombo.setData(categoriesToSet, categoriesToSet[0]);
        this.categoriesCombo.setSelected(categoriesToSet[0]);
    }
    /**
     * {@inheritdoc}
     *
     * @return {*}  {void}
     * @memberof AthleteWcupRankingFiltersService
     */
    generateDefaultValues() {
        return;
    }
    getDataStreamWithFilters() {
        return combineLatest([this.categoriesReady.asObservable(), this.categoriesCombo.comboData, this.eventTypeCombo.comboData]).pipe(filter(a => a[0] === true), map(a => {
            return [a[1], a[2]];
        }));
    }
}
AthleteWcupRankingFiltersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AthleteWcupRankingFiltersService_Factory() { return new AthleteWcupRankingFiltersService(i0.ɵɵinject(i1.FiltersAthleteGeneralService)); }, token: AthleteWcupRankingFiltersService, providedIn: "root" });
